module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAArElEQVRYhe3Yuw3CMBSF4RMmYAJXHgxKV4gNGCFULslgrjwBGxCJMpJ9/JATgc5fRsm9n6ykCRRp6jmg4MwLwGVzebE+XltnNoMSmG5UEkQW9pYEnzKDR2Gys3OgQ8qBloF7R87+84o/++DMp+corI9Fu37qpT4kgVgCsQRiCcQSiCUQSyCWQCyBWHuB3iNAc5vl27P0xqq/H8GZB4AbgHPFY7P18V6zRyUDsAKqahxJ/VoKBwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_btn_delete_press@2x.png
// module id = 734
// module chunks = 0